(function ($) {
  $('.project-pic-slider').slick({
    fade: true,
    arrows: false,
    dots: true,
    swipe: true,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
  });
})($);